import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../redux/axios';

const initialState = {
    NotificationData: [],
    notifyCount: 0,
    isFetching: false,
    isNotifySuccess: false,
    isError: false,
    errorMessage: '',
    imagePath: '',
};

export const getNotificationList = createAsyncThunk(
    '/notification/list',
    async (udata, thunkAPI) => {
        try {
            const { auth } = thunkAPI.getState()
            let tokenStr = auth.user.token;
            let response = await axios({
                url: `/api/notification/list`,
                method: 'get',
                headers: {
                    "Authorization": `Bearer ${tokenStr}`
                }
            })

            let data = response.data;
            if (response.status === 200) {
                return data;
            }
            else if (data.code === 200) {
                return data;
            }
            else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return thunkAPI.rejectWithValue(err.response.data)
        }
    }
);




export const NotificationListSlice = createSlice({
    name: 'viewnotification',
    initialState,
    reducers: {
        clearStateListNotification: (state, { payload }) => {
            state.NotificationData = [];
            state.notifyCount = 0;
            state.isFetching = false;
            state.isNotifySuccess = false;
            state.isError = false;
            state.errorMessage = '';
            state.imagePath = '';
        },
    },

    extraReducers: {
        [getNotificationList.fulfilled]: (state, { payload }) => {
            state.NotificationData = payload.data.data;
            state.imagePath = payload.data.imagePath;
            state.notifyCount = payload.data.dataCount;
            state.isFetching = false;
            state.isNotifySuccess = true;
            return state;
        },
        [getNotificationList.pending]: (state) => {
            state.isFetching = true;
        },
        [getNotificationList.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            if (payload) {
                state.errorMessage = payload.message;
            }
            else {
                state.errorMessage = 'Internal error';
            }
        }
    },
});

export const takeActionAsyn = (pdata) => async (dispatch, getState) => {
    try {
        const { auth } = getState()
        let tokenStr = auth.user.token;
        let userType = auth.user.userType == 'CHD' ? 'chd' : auth.user.userType == "DD's & AD's" ? 'DDsAndAds' : 'clerk';
        let response = await axios({
            url: `/api/${userType}/document/detailed?processId=${pdata}`,
            method: 'get',
            //timeout: 8000,
            headers: {
                //'Content-Type': 'application/json',
                "Authorization": `Bearer ${tokenStr}`
            }
        })

        let data = response.data;
        return data;
        // console.log(data.data)
        //dispatch(getAllUserDepartments(data));
    } catch (error) {
        return error.response.data;
    }
};



export const takeActionChildProcessAsyn = (pdata) => async (dispatch, getState) => {
    try {
        const { auth } = getState()
        let tokenStr = auth.user.token;
        let userType = auth.user.userType == 'CHD' ? 'chd' : auth.user.userType == "DD's & AD's" ? 'DDsAndAds' : 'clerk';
        let response = await axios({
            url: `/api/${userType}/v2/document/detailed?processId=${pdata}`,
            method: 'get',
            headers: {
                "Authorization": `Bearer ${tokenStr}`
            }
        })

        let data = response.data;
        return data;
    } catch (error) {
        return error.response.data;
    }
};


export const clickReadableUserAsyn = (pdata) => async (dispatch, getState) => {
    try {
        const { auth } = getState()
        let tokenStr = auth.user.token;
        const response = await axios.post('/api/notification/takeAction', pdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

        let data = response.data;
        return data;
    } catch (error) {
        return error.response.data;
    }
};



export const { clearStateListNotification } = NotificationListSlice.actions;

export function clearState() {

    return async (dispatch) => {
        dispatch(clearStateListNotification());
    }
}

export const ViewNotificationSelector = (state) => state.viewnotification;

export default NotificationListSlice.reducer;
